import { Injectable } from '@angular/core';
import { Http, XHRBackend, RequestOptions, Request, RequestOptionsArgs, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Router, ActivatedRoute  } from '@angular/router';
import { AuthenticationService } from './index';
import { NotificationsService } from 'angular2-notifications';
import { AuthHelper } from '../shared/auth-helper';

@Injectable()
export class ExtendedHttpService extends Http {

  router: Router;
  auth: AuthenticationService;
  notify: NotificationsService;

  constructor(backend: XHRBackend, options: RequestOptions,
    router: Router, notificationsService: NotificationsService) {
    const token = AuthHelper.GetRawToken();
    if (token !== '') {
      options.headers.set('Authorization', `Bearer ${token}`);
    }
    super(backend, options);
    this.router = router;
    this.notify = notificationsService;
   }

  request(url: string | Request, options?: RequestOptionsArgs): Observable<Response> {
    const token = AuthHelper.GetRawToken();

    if (typeof url === 'string') { // meaning we have to add the token to the options, not in url
      if (!options) {
        // let's make option object
        options = { headers: new Headers() };
      }
      if (token !== '') {
        options.headers.set('Authorization', `Bearer ${token}`);
      }
    } else {
      // we have to add the token to the url object
      if (token) {
        url.headers.set('Authorization', `Bearer ${token}`);
      }
    }
    return super.request(url, options).catch(this.catchAuthError(this));
  }

  private catchAuthError(self: ExtendedHttpService) {
    // we have to pass HttpService's own instance here as `self`
    return (res: Response) => {
      if (res.status === 403) {
        self.notify.warn('Warning!', 'Insufficient Permission to perform this action.');
      } else if (res.status === 401){
        self.notify.warn('Warning!', 'Session Timeout! Please Relogin .');
        localStorage.removeItem('currentUser');
        this.router.navigate(['/login']);
      } else if (res.status === 400){
        this.notify.error('Error!', (res as any)._body);
      } else {
        this.notify.error('Error!', 'Server Error. Please try again');
      }
      return Observable.throw(res);
    };
  }
}
